export default __webpack_public_path__ + "static/media/1848.0607399b.png";